import DadosBancarioTipo from "@/Models/Pessoa/dadosBancario/DadosBancarioTipo";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useDadosBancarioTipoListar({
    dadosBancarioTipo,
    ativo,
    ...rest
}:QueryBasicaParam<AxiosResponse<DadosBancarioTipo[]>, DadosBancarioTipo[], {
    dadosBancarioTipo?:DadosBancarioTipo,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(dadosBancarioTipo ?? {}),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : ["Pessoa", "DadosBancario", "Tipo", "ListarTodos", queryString ],
        queryFn : () => Axios.get<DadosBancarioTipo[]>(`pessoa/dadosBancario/tipo?${queryString}`),
        staleTime : 1000 * 60 * 2.5,
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                return m;
            });
        },
    });
}